import { UseFormReturn } from 'react-hook-form';
import { ReactNode } from 'react';

import { OrderMethod } from 'src/types';
import { AdminDashboardMetricDto, FilterFileResolutionRequest, GettingFileResolutionDto, InvoiceFileProcessingDto } from 'src/generated/services/TFinancialApi';
import { ViewMode } from './validateInvoice/ViewMode';
import { ValidateInvoiceStep } from '../../molecules/uploadInvoice/types.ts';

// eslint-disable-next-line @typescript-eslint/naming-convention
export enum ROW_ACTION_TYPE {
  RESOLUTION_MESSAGE = 'RESOLUTION_MESSAGE',
  ERROR_MESSAGE = 'ERROR_MESSAGE',
  RESOLVE = 'RESOLVE',
  EDIT_INVOICE = 'EDIT_INVOICE',
  EDIT_OCR = 'EDIT_OCR',
  EDIT_CONFIG = 'EDIT_CONFIG',
  USER_MESSAGE = 'USER_MESSAGE',
  VALIDATE_INVOICE = 'VALIDATE_INVOICE',
  REPROCESS_SHIPMENT = 'REPROCESS_SHIPMENT',
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export enum SORTING_DIRECTION {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type TTableType = 'file_resolution' | 'user_resolution';
export interface IInternalDashboardMainProps {}

export interface IInternalDashboardContentProps {}

export interface IInternalDashboardHeaderProps {
  items: AdminDashboardMetricDto;
  isLoading: boolean;
}

export interface IInternalDashboardTableProps {}

export interface IInternalTableIssuesProps {
  data: GettingFileResolutionDto[];
  totalItems: number;
  onChangePage?: (page: number) => void;
  onSorting: (newMethod: SORTING_DIRECTION, fieldName: string) => void;
  orderMethod?: OrderMethod;
  orderBy?: string;
  numberOfRows?: number;
  params?: any;
  isHidePagination?: boolean;
  isCollapsible?: boolean;
  isLoading?: boolean;
}

export interface IInternalTableFilesProps {
  data: InvoiceFileProcessingDto[];
  totalItems: number;
  onChangePage?: (page: number) => void;
  onSorting: (newMethod: SORTING_DIRECTION, fieldName: string) => void;
  orderMethod?: OrderMethod;
  orderBy?: string;
  numberOfRows?: number;
  params?: any;
  isHidePagination?: boolean;
  isCollapsible?: boolean;
  isLoading?: boolean;
}

export interface IInternalDashboardFilterParams {
  page?: number;
  size?: number;
  fileResolutionStatuses?: FilterFileResolutionRequest['fileResolutionStatuses'];
  dateFrom?: string;
  dateTo?: string;
  tabName?: string;
  paramsIsNull?: boolean;
  sortingColum?: string;
  sortingDirection?: SORTING_DIRECTION;
}

export interface IInternalDashboardValues {
  selectedRow: GettingFileResolutionDto;
  selectedRowType: TTableType;
  rowActionType: ROW_ACTION_TYPE;
  isShowResolutionMessage: boolean;
  isShowUserMessage: boolean;
  isShowErrorMessage: boolean;
  isShowEditInvoiceData: boolean;
  isShowEditOcrData: boolean;
  isShowEditConfig: boolean;
  isShowResolve: boolean;
  isShowReprocessShipment: boolean;
  isActionLoading: boolean;
  isValidateInvoice: boolean;
  resolvedStatuses: string[];
  unresolvedStatuses: string[];

  filterParams: IInternalDashboardFilterParams;
  runRowAction(rowData: GettingFileResolutionDto | InvoiceFileProcessingDto, actionType: ROW_ACTION_TYPE, tableType?: TTableType): void;
  stopRowAction(): void;
  setIsActionLoading(status: boolean): void;
  setFilterPage(newPage: number): void;
  setFilterTabName(tabName: string): void;
  setFilterStatuses(statuses: string[]): void;
  checkRowAction(actionType: ROW_ACTION_TYPE): boolean;
  setSorting(fieldName: string, method: SORTING_DIRECTION): void;
}

export type TUpdateValues = Record<string, any>;

export interface IModalUpdateBaseProps {
  actionType: ROW_ACTION_TYPE;
  title?: string;
  formContext: UseFormReturn<TUpdateValues, any, undefined>;
  children: ReactNode;
  onSubmit?: (values: TUpdateValues) => void;
  setViewMode?(newPage: ViewMode): void;
  viewMode?: ViewMode;
  isValidJson?: boolean;
  onValidateForm?: (values: TUpdateValues) => void;
  activeStep?: ValidateInvoiceStep;
  setActiveStep?: (step: ValidateInvoiceStep) => void;
}

export interface IButtonRowActionProps {
  data: GettingFileResolutionDto | InvoiceFileProcessingDto;
  actionType: ROW_ACTION_TYPE;
}

export interface IRowActionMenuProps {
  data: GettingFileResolutionDto;
  tableType?: TTableType;
}

export interface IFilterOptionDTO {
  value: string;
  label: string;
  count: number;
}
